import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { autoserialize, autoserializeAs } from 'cerialize';
import { isString } from 'lodash';
import { PaymentMethod } from './payment-method';

export class OrganizationPaymentMethod {
  @autoserialize id: number;

  @autoserialize organizationId: number;

  @autoserializeAs(PaymentMethod) paymentMethod: PaymentMethod;

  @autoserialize name: string;

  @autoserialize ticketNumberRegex: string;

  @autoserialize ticketValidValues: Array<number>;

  @autoserialize validNumberOfUses: number;

  @autoserialize ticketNumberRequired: boolean;

  @autoserialize metadata: object;

  /**** Serialization ****/

  static OnSerialized(instance: OrganizationPaymentMethod, json: any): void {
    if (!isNullOrUndefined(instance.metadata)) {
      json.metadata = JSON.stringify(instance.metadata);
    }

    if (!isNullOrUndefined(instance.ticketValidValues)) {
      json.ticketValidValues = instance.ticketValidValues.join(',');
    }
  }

  static OnDeserialized(instance: OrganizationPaymentMethod, json: any): void {
    if (!isNullOrUndefined(json['metadata'])) {
      try {
        if (!isString(json['metadata'])) {
          json['metadata'] = JSON.stringify(json['metadata']);
        }

        instance.metadata = JSON.parse(json['metadata']);
      } catch (err) {
        // Throwing an exception will cause the ride to be inaccessible
        // App will fall back to defaults
      }
    }

    if (!isNullOrUndefined(json['ticketValidValues'])) {
      instance.ticketValidValues = json['ticketValidValues'].split(',').map(value => +value.trim());
    }
  }
}
